
<div
  v-if="activeSlider"
  class="rfp-rr-title-section-177-or review-popup-overlay"
  style="display: block; overflow: auto"
>
  <div
    v-if="showWarningPopup"
    class="rfp-rr-write-review-warning-240-or review-popup full-review-active selectPage-in-drop-down"
    data-popup="review-popup"
    style="display: block"
  >
    <div class="rfp-rr-write-review-warning-241-or review-popup-close" @click="closePopup">
      {{ popupClose }}
    </div>
    <div
      id="messageSuccess"
      class="rfp-rr-write-review-warning-242-or popup-inner"
      style="display: block"
    >
      <div
        class="rfp-rr-write-review-warning-243-or message-icon success"
        :class="{ 'image--display': warningIcon === '' }"
      >
        <img :src="warningIcon" :style="{ width: '100%' }" :alt="warningIconAltText" />
      </div>
      <div class="rfp-rr-write-review-warning-244-or message" v-html="warningText"></div>
    </div>
  </div>
</div>
